'use client';

import Marquee from 'react-fast-marquee';
import Image from 'next/image';

const PartnerCarousel = () => {
    const partners = [
        { src: '/partners/circle-india.svg', alt: 'Circle of India' },
        { src: '/partners/teach-india2.png', alt: 'Teach for India' },
        { src: '/partners/kairos3.png', alt: 'Kairos Logo' },
        { src: '/partners/bosch.svg', alt: 'Bosch Logo' },
        { src: '/partners/enpro.png', alt: 'Enpro Industries Logo' },
        { src: '/partners/circle-india.svg', alt: 'Circle of India' },
        { src: '/partners/teach-india2.png', alt: 'Teach for India' },
        { src: '/partners/kairos3.png', alt: 'Kairos Logo' },
        { src: '/partners/bosch.svg', alt: 'Bosch Logo' },
        {
            src: '/partners/enpro.png',
            alt: 'Enpro Industries Logo',
        },
    ];

    return (
        <Marquee pauseOnHover speed={100} gradient={false} className="gap-x-12">
            {partners.map((partner, index) => (
                <div
                    key={index}
                    className="h-36 flex items-center px-6" // padding inside instead of margin
                >
                    <Image
                        src={partner.src}
                        alt={partner.alt}
                        width={200}
                        height={100}
                        className="object-contain max-h-36"
                    />
                </div>
            ))}
        </Marquee>
    );
};

export default PartnerCarousel;
